import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";

export async function addGroupFormPenilaian(data) {
  try {
    const response = await baseAxios.post(
      `groupFormPenilaian/addGroupFormPenilaian`,
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getGroupFormPenilaian(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `groupFormPenilaian/getGroupFormPenilaian?status&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_GET_ALL_GROUP_PENILAIAN", data: response.data });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function addJenisPenilaian(data) {
  try {
    const response = await baseAxios.post(
      `jenisPenilaian/addJenisPenilaian`,
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getJenisPenilaian(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `jenisPenilaian/getJenisPenilaian?idGroupFormPenilaian=${data.idGroupFormPenilaian}&status&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_GET_ALL_JENIS_PENILAIAN", data: response.data });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function addKriteriaPenilaian(data) {
  try {
    const response = await baseAxios.post(
      `kriteriaPenilaian/addKriteriaPenilaian`,
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getKriteriaPenilaian(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `kriteriaPenilaian/getKriteriaPenilaian?idJenisPenilaian=${data.idJenisPenilaian}&status&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_GET_ALL_KRITERIA_PENILAIAN", data: response.data });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function addParameterPenilaian(data) {
  try {
    const response = await baseAxios.post(
      `parameterPenilaian/addParameterPenilaian`,
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function getParameterPenilaian(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `parameterPenilaian/getParameterPenilaian?idKriteria=${data.idKriteria}&status&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    dispatch({ type: "SET_GET_ALL_PARAMETER_PENILAIAN", data: response.data });
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function updateStatusFormGroup(data) {
  try {
    const response = await baseAxios.patch(
      `groupFormPenilaian/updateStatusGroupFormPenilaian?idGroupFormPenilaian=${data.idGroupFormPenilaian}&status=${data.status}`,
      data,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    return response.data;
  } catch (err) {
    return err.response;
  }
}

export async function detailGrupPenilaian(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `groupFormPenilaian/getAllDataGroupFormPenilaian?idGroupFormPenilaian=${data.idGroupFormPenilaian}&status&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      },
    );
    // console.log(response, "RESPONSE");
    dispatch({ type: "SET_DETAIL_GRUP__PENILAIAN", data: response.data });
    return response.data;
  } catch (err) {
    return err.response;
  }
}
